export default "__VITE_ASSET__BvvuLJZ5__"